/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

import {LocaleNumberPipe} from '../filters/locale-number.pipe';

import {TARGETING_IMPORTS} from '../../targeting/targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-sentiment-result',
  template: `<label [title]="title" class="label {{labelClass}}">{{ text }}</label>`
})
export class SentimentResultComponent implements OnChanges {
  @Input() score: number;
  text = '';
  labelClass = '';
  title = '';

  constructor(private localeNumberPipe: LocaleNumberPipe) {
  }

  ngOnChanges(): void {
    if (this.score <= 0) {
      this.text = 'Negative';
      this.labelClass = 'label-warning';
    } else if (this.score > 1) {
      this.text = 'Positive';
      this.labelClass = 'label-success';
    } else {
      this.text = 'Neutral';
      this.labelClass = 'label-info';
    }
    this.title = `Score: ${this.localeNumberPipe.transform(this.score, '1.3-3')}`;
  }
}
